import { trackEvent, type WhatsappCtaLocation } from "@/lib/dataLayer";

export const WHATSAPP_PHONE = "5519936195831";
export const WHATSAPP_URL = `https://wa.me/${WHATSAPP_PHONE}`;

export function openWhatsApp(location: WhatsappCtaLocation) {
  trackEvent({ event: "cta_click_whatsapp", location });
  // Atualiza o hash da URL para "#contato" apenas para o GTM/GA capturar
  // o clique via trigger de mudança de URL (History Change).
  window.location.hash = "contato";
  window.open(WHATSAPP_URL, "_blank");
}
